export const BACKEND_BASE_URL = 'https://apiautoincloud.s3.lascomedia.com';
export const API_BASE_URL = `${BACKEND_BASE_URL}/api/v1`;
export const STORAGE_URL = `${BACKEND_BASE_URL}/storage`;